import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { ConsolePanel } from '@/ui';

const Panel = styled(ConsolePanel)`text-align: center; padding: 40px 24px; display: flex; flex-direction: column; gap: 12px; align-items: center;`;
const H = styled.h1`margin: 0; font-family: ${({ theme }) => theme.font.display}; font-size: ${({ theme }) => theme.fontSize.lg}; color: ${({ theme }) => theme.color.textPrimary};`;
const P = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;
const Back = styled(Link)`color: ${({ theme }) => theme.color.brandFrom}; text-decoration: none; font-weight: 600;`;

export function CommunityNotFound() {
  return (
    <Panel role="alert">
      <H>Community not found</H>
      <P>This community doesn&apos;t exist or has been removed.</P>
      <Back to="/communities">Back to Communities</Back>
    </Panel>
  );
}
